export default __webpack_public_path__ + "static/media/stay.353dc2e4.png";